import React, {Component} from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import config from 'config';
import qs from 'qs';
import Modal from 'react-modal';
import LanguageLabel from '../management/clients/LanguageLabel';
import BottomTriangle from '../../../../assets/BottomTriangle';
import BillingComponent from './BillingComponent';
import {
    calculateTariffPrice,
    editDraft,
    getTariffByStatus,
    handlePaymentResponse,
    pay
} from '../../../../services/company/api';
import {TariffsContainer} from '../../../../components/tariff';
import TariffChange from './TariffChange';
import LoadingComponent from '../../../../assets/LoadingComponent'
import ErrorContent from "./ErrorContent";

const styles = {
    wrapper: {
        padding: '40px 60px',
        background: '#FFFFFF',
        overflow: 'auto',
        height: '100vh',
        borderRadius: '20px',
        margin: '30px',
        maxHeight: 'calc(100vh - 125px)',
    },
    header2: {
        color: '#3D568F',
        fontSize: '22px',
        marginBottom: '50px',
    },
    header: {
        height: '60px',
        padding: '20px 40px',
        fontSize: '16px',
        lineHeight: '20px',
        color: '#A4ADC1',
    },
    billingContainer: {
        margin: '40px 75px 0px 75px',
        boxShadow: '5px 5px 15px #183E9952',
    },
    cardsWrapper: {
        display: 'flex',
    },
    localesListWrapper: {
        display: 'flex',
        borderTop: '1px solid rgba(24,62,153,0.17)',
    },
    localeWrapper: {
        width: '50%',
    },
    localeHeadingBorder: {
        borderRight: '1px solid rgba(24,62,153,0.17)',
    },
    localeHeading: {
        height: '54px',
        lineHeight: '60px',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 100,
        borderBottom: '1px solid rgba(24,62,153,0.17)',
        WebkitBoxShadow: '1px 3px 3px 0px rgba(24, 62, 153, 0.17)',
        MozBoxShadow: '1px 3px 3px 0px rgba(24, 62, 153, 0.17)',
        boxShadow: '1px 3px 3px 0px rgba(24, 62, 153, 0.17)',
    },
    localeMessagesWrapper: {
        padding: '0px 40px 30px 40px',
    },
    localeName: {
        fontSize: '12px',
        lineHeight: '20px',
        height: '20px',
        fontWeight: 600,
        color: '#09183A',
        marginBottom: '10px',
        marginTop: '20px',
    },
    separatorLine: {
        border: '1px solid #F6F8FB',
        width: '400px',
    },
    expiration: {
        padding: '5px 15px 10px',
    },
    item: {
        height: '360px',
        padding: '0 18px',
        flexBasis: '60px',
        display: 'flex',
        alignItems: 'center',
        borderRight: '1px solid #F2F5FB',
        cursor: 'pointer',
        position: 'relative',
    },
    smallCard: {
        padding: '20px 40px',
        flexGrow: 100,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        WebkitBoxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
        MozBoxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
        boxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
    },
    selectedItem: {
        height: '375px',
    },
    itemSmallPadding: {
        padding: '8px',
    },
    itemIcon: {
        flexGrow: 1,
    },
    clientName: {
        flexGrow: 1,
    },
    navLink: {
        padding: '15px',
    },
    nlpSwitch: {
        marginLeft: '10px',
    },
    removeItem: {
        padding: '22px',
        backgroundColor: '#E14E52',
    },
    modalStyle: {
        overlay: {
            backgroundColor: config.modalBackgroundColor,
            zIndex: '2000',
        },
        content: {
            width: '457px',
            borderRadius: '20px',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            border: 'none',
            padding: 'none',
        },
    },
};

const planStyles = {
    wrapper: {
        height: '60px',
        display: 'flex',
        WebkitBoxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
        MozBoxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
        boxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
    },
    item: {
        position: 'relative',
        height: '53px',
        flexGrow: 1,
        textAlign: 'center',
        lineHeight: '60px',
        // WebkitBoxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
        // MozBoxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
        // boxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
    },
    selectedItem: {
        height: '375px',
    },
    itemSmallPadding: {
        padding: '8px',
    },
    itemIcon: {
        flexGrow: 1,
    },
    clientName: {
        flexGrow: 1,
    },
    navLink: {
        padding: '15px',
    },
    nlpSwitch: {
        marginLeft: '10px',
    },
    removeItem: {
        padding: '22px',
        backgroundColor: '#E14E52',
    },
};

const TabIds = {
    current: 1,
    future: 2,
};

class Billing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isOpenModal: false,
            isOpenErrorModal: false,
            payClick: true,
            errorContent: {},
            activeTabId: TabIds.current,
            currentPlan: {},
            futurePlan: {},
            tariff: {},
            planOption: config.planOptions[0],
            company: {},
            bindingCards: [],
            btnState: true,
        };
    }

    async componentDidMount() {
        this.setState({loading: true});
        const {location: {search}, addNotification, company} = this.props;
        const queries = qs.parse(search, {ignoreQueryPrefix: true});

        function validateQueryParams(queries) {
            return queries.orderID !== undefined
                && queries.resposneCode !== undefined
                && queries.paymentID !== undefined
                && queries.opaque !== undefined
                && queries.description !== undefined;
        }

        if (validateQueryParams(queries)) {
            const payment = {
                orderId: queries.orderID,
                responseCode: queries.resposneCode,
                paymentId: queries.paymentID,
                opaque: queries.opaque,
                description: queries.description,
            };

            await handlePaymentResponse(payment)
                .then((response) => {
                    addNotification('paymentSuccess', config.notificationLevels.success);
                    setTimeout(() => {
                        window.location = '/dashboard/billing';
                    }, 500)
                    if (response.status === 201) {
                        company.bindingCards.push(response.data);
                        this.setState({
                            company,
                        });
                    } else {
                        this.setState({
                            company: response.data.company,
                            currentPlan: response.data,
                        });
                    }
                })
                .catch((error) => {
                    addNotification('paymentFailed', config.notificationLevels.error);
                });
        }
        this.refreshTariff();
    }

    refreshTariff = () => {
        const currentStatus = 'status=ACTIVE&status=TRIAL&status=PAYMENT_REQUIRED';
        const futureStatus = 'status=DRAFT&status=DRAFT_PAID';

        Promise.all([getTariffByStatus(currentStatus), getTariffByStatus(futureStatus)])
            .then((results) => {
                this.setState({
                    currentPlan: results[0],
                    futurePlan: results[1],
                    loading: false,
                    company: results[0].company,
                });
            });
    };

    handleTabClick = (tabId, planOption) => () => {
        const {activeTabId} = this.state;

        if (tabId === activeTabId) return;

        let nextActiveTabId = -1;
        if (activeTabId !== tabId) {
            nextActiveTabId = tabId;
        }

        this.setState({
            activeTabId: nextActiveTabId,
            planOption,
        });
    };

    handleChangeButtonClick = (data) => {
        const {activeTabId, currentPlan, futurePlan} = this.state;
        const plan = activeTabId === 1 ? currentPlan : futurePlan;

        calculateTariffPrice(data.packageId, plan.tariffStatus, 'MONTHLY', data.additionalOperators, data.additionalClients)
            .then((responseData) => {
                this.setState({
                    isOpenModal: true,
                    tariff: responseData,
                    // btnState: !(plan.tariffPackage.id === responseData.tariffPackage.id && plan.additionalOperators === responseData.additionalOperators && plan.additionalClients === responseData.additionalClients)
                    btnState: true
                });
            })
            .catch((error) => {
                this.setState({
                    errorContent: error.response,
                    isOpenErrorModal: true,
                });
            });
    };

    handlePayButton = (isBinding, cardHolderId) => {
        const {tariff, activeTabId, currentPlan, futurePlan} = this.state;
        const tariffStatus = activeTabId === 1 ? currentPlan.tariffStatus : futurePlan.tariffStatus;
        this.payRequest(tariff, tariffStatus, tariffStatus === 'DRAFT', isBinding, cardHolderId)
    };

    handleDraftPay = () => {
        const {currentPlan} = this.state;
        calculateTariffPrice(
            currentPlan.tariffPackage.id,
            currentPlan.tariffStatus,
            'MONTHLY',
            currentPlan.additionalOperators,
            currentPlan.additionalClients
        )
            .then((data) => {
                this.setState({
                    isOpenModal: true,
                    tariff: data,
                });
            })
            .catch((error) => {
                this.setState({
                    errorContent: error.response,
                    isOpenErrorModal: true,
                });
            });
    };

    payRequest = (tariff, tariffStatus, isDraft, isBinding, cardHolderId) => {
        const {payClick} = this.state;
        const {addNotification} = this.props;
        if (payClick) {
            this.setState({payClick: false});
            if (isDraft) {
                const editTariffPayload = {
                    tariffPackageId: tariff.tariffPackage.id,
                    additionalOperators: tariff.additionalOperators,
                    additionalClients: tariff.additionalClients,
                };
                editDraft(editTariffPayload)
                    .then((response) => {
                        this.setState({
                            futurePlan: response.data,
                            isOpenModal: false,
                            payClick: true
                        })
                    })
                    .catch((error) => {
                        this.setState({
                            errorContent: error.response,
                            isOpenErrorModal: true,
                            payClick: true,
                        });
                    });
            } else {
                pay(tariffStatus, isBinding, cardHolderId)
                    .then((response) => {
                        if (cardHolderId !== -1) {
                            addNotification('paymentSuccess', config.notificationLevels.success);
                            this.setState({
                                isOpenModal: false,
                                payClick: true,
                            });
                            this.refreshTariff();
                            window.location.reload();
                        } else if (response.status === 201) {
                            window.location.href = response.data;
                        } else if (response.status === 200) {
                            window.location.reload();
                            this.setState({
                                company: response.data.company,
                                currentPlan: response.data,
                                isOpenModal: false,
                                payClick: true
                            });
                        }
                    })
                    .catch((error) => {
                        this.setState({
                            errorContent: error.response,
                            isOpenErrorModal: true,
                            payClick: true,
                            isOpenModal: false,
                        });
                    });
            }
        }
    };

    closeModal = () => {
        this.setState({isOpenModal: false});
    };

    closeErrorModal = () => {
        this.setState({isOpenErrorModal: false});
    };

    render() {
        const {
            loading,
            activeTabId,
            currentPlan,
            futurePlan,
            tariff,
            isOpenModal,
            isOpenErrorModal,
            company,
            errorContent,
            btnState
        } = this.state;

        const { user } = this.props

        if (loading) {
            return <LoadingComponent/>;
        }

        const plans = config.planOptions.map(planOption => ({
            component: LanguageLabel,
            props: {planOption},
            defaultStyles: Object.assign({cursor: 'pointer'}, planStyles.item),
            tabId: TabIds[planOption.value],
        }));

        return (
            <div style={styles.wrapper}>
                <div style={styles.cardsWrapper}>
                    {
                        plans.map((plan) => {
                            const styles = [plan.defaultStyles];
                            return (
                                <div
                                    key={plan.tabId}
                                    style={styles}
                                    onClick={this.handleTabClick(plan.tabId, plan.props.planOption)}
                                >
                                    <plan.component
                                        localeOption={plan.props.planOption}
                                        fontStyle={activeTabId === plan.tabId ? {fontWeight: 'bold'} : {}}
                                    />
                                    <BottomTriangle size={activeTabId === plan.tabId ? 20 : 0} color="#FFFFFF"/>
                                </div>
                            );
                        })
                    }
                </div>
                {
                    <div>
                        <div>
                            <BillingComponent
                                user={user}
                                onPayClick={this.handleDraftPay}
                                company={company}
                                tabId={activeTabId}
                                tariff={tariff}
                                plan={activeTabId === 1 ? currentPlan : futurePlan}
                            />
                        </div>
                        <Modal closeTimeoutMS={config.closeTimeoutMS}
                               isOpen={isOpenModal}
                               onRequestClose={this.closeModal}
                               style={styles.modalStyle}
                        >
                            <TariffChange
                                user={user}
                                tariff={tariff}
                                btnState={btnState}
                                onHandleCancel={this.closeModal}
                                onHandlePay={this.handlePayButton}
                                tabId={activeTabId}
                                country={company.country}
                                cards={company.bindingCards}
                                isActiveTariff={activeTabId === 1}
                            />
                        </Modal>
                        <Modal closeTimeoutMS={config.closeTimeoutMS}
                               isOpen={isOpenErrorModal}
                               onRequestClose={this.closeErrorModal}
                               style={styles.modalStyle}
                        >
                            <ErrorContent errorMessage={errorContent} closeModal={this.closeErrorModal}/>
                        </Modal>
                        <TariffsContainer company={company}
                                          user={user}
                                          plan={activeTabId === 1 ? currentPlan : futurePlan}
                                          handleSelect={(data) => {
                                              this.handleChangeButtonClick(data);
                                          }}
                        />
                    </div>
                }
            </div>
        );
    }
}

Billing.propTypes = {
    company: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
};

export default Radium(Billing);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/billing/index.jsx